"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    calendarVariants: ()=>calendarVariants
});
const tv_cjs_namespaceObject = require("../../../variants/tv.cjs");
const calendarVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'bg-primary-1 relative box-border',
        monthCaption: 'flex w-full items-center justify-center py-2',
        buttonPreviousContainer: 'absolute left-0 top-0 flex cursor-pointer',
        buttonNextContainer: 'absolute right-0 top-0 flex cursor-pointer',
        buttonPrevious: 'h-8 w-8',
        buttonNext: 'h-8 w-8',
        captionLabel: 'text-heading5 text-primary-13 capitalize',
        nav: '',
        months: 'relative flex [&>div:not(:first-of-type)]:ml-4',
        month: 'flex flex-col',
        weekdays: 'py-2',
        weekRow: [
            ''
        ],
        weekHeader: [
            ''
        ],
        daysGrid: [
            ''
        ],
        weeks: '',
        week: '',
        weekday: 'text-body3 text-primary-10 h-11 w-11',
        weekNumber: '',
        day: [
            'focus-visible:outline-none',
            'text-body1 aspect-square h-11 w-11'
        ],
        dayButton: [
            'h-full max-h-11 w-full',
            'text-body1 text-neutral-11 box-border flex cursor-pointer items-center justify-center rounded-lg',
            'hover:text-neutral-12 hover:bg-primary-4',
            'disabled:text-neutral-6 disabled:cursor-not-allowed disabled:hover:bg-transparent'
        ],
        today: '',
        outsideDay: 'text-neutral-8',
        selectedDays: [
            '[&>button]:bg-primary-8 [&>button]:text-primary-1 [&>button]:hover:bg-primary-8 [&>button]:hover:text-primary-1',
            '[&>button]:border-none [&>button]:focus-visible:outline-none [&>button]:focus-visible:ring-transparent'
        ],
        rangeStart: [
            'range-start',
            '[&>button]:rounded-br-none [&>button]:rounded-tr-none'
        ],
        rangeMiddle: [
            'range-middle',
            '[&>button]:bg-primary-11 [&>button]:text-primary-1 [&>button]:hover:bg-primary-11 [&>button]:hover:text-primary-1',
            '[&>button]:rounded-bl-none [&>button]:rounded-br-none [&>button]:rounded-tl-none [&>button]:rounded-tr-none'
        ],
        rangeEnd: [
            'range-end',
            '[&>button]:rounded-bl-none [&>button]:rounded-tl-none'
        ],
        hoveredRangeStart: 'bg-primary-8 rounded-l-lg',
        hoveredRangeEnd: 'bg-primary-8 [&>button]:hover:bg-primary-8 [&>button]:hover:text-primary-1 [&>button]:text-primary-1 rounded-r-lg',
        chevron: 'fill-primary-8 inline-block h-5 w-5',
        dropdowns: '',
        dropdown: '',
        dropdownRoot: '',
        monthGrid: '',
        disabled: 'text-neutral-6 cursor-not-allowed',
        hidden: 'invisible',
        focusable: ''
    },
    variants: {
        isDayMap: {
            true: {
                day: 'h-12',
                dayButton: 'max-h-12'
            }
        },
        isMobile: {
            true: {
                root: 'w-full',
                months: 'flex flex-col gap-1 [&>div:not(:first-of-type)]:ml-0',
                monthCaption: 'justify-start'
            }
        }
    }
});
exports.calendarVariants = __webpack_exports__.calendarVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "calendarVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
